import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ProductCertificateType } from "src/app/domain/models/ProductCertificateType";

@Injectable({providedIn: 'root'})
export abstract class ProductCertificateTypeGateway {
  abstract getAll(): Observable<Array<ProductCertificateType>>
}
